import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeedbackRequest, FeedbackResponse } from './models';

export interface PingResponse {
  message: string;
}

@Injectable({ providedIn: 'root' })
export class FeedbackApiService {
  private readonly http = inject(HttpClient);

  /**
   * Health check / warm-up endpoint for feedback service
   * Returns a simple pong response to verify backend availability
   */
  ping(): Observable<PingResponse> {
    return this.http.get<PingResponse>('uservoice/ping');
  }

  submitFeedback(request: FeedbackRequest): Observable<FeedbackResponse> {
    return this.http.post<FeedbackResponse>('uservoice/feedback', request);
  }
}
